<template>
    <div class="filter-content-button-on-mobile">
        <p class="btn btn-warning" style="width: 100%" @click="filterContentToggle">
            {{ $t('common_open_filter') }}
        </p>
    </div>
    <div class="filter-content">
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: "FilterMainContentBox",
    methods: {
        filterContentToggle(){
            let contentStyle = document.getElementsByClassName('filter-content').item(0).style["display"]
            if(contentStyle === 'block' || !contentStyle){
                document.getElementsByClassName('filter-content').item(0).style["display"] = "none"
            }else{
                document.getElementsByClassName('filter-content').item(0).style["display"] = "block"
            }
        }
    }
}
</script>

<style scoped>
/*PC Screen*/
@media screen and (min-width : 1023px) and (max-width : 9999px){
    .filter-content{
        display: block;
    }
    .filter-content-button-on-mobile{
        display: none;
    }
}

/*Mobile screen*/
@media screen and (min-width : 0px) and (max-width : 1023px){
    .filter-content{
        display: block;
    }
    .filter-content-button-on-mobile{
        display: block;
    }
}
</style>
